import {
  CUSTOMER_POOL_ANEW_REQUSET_DATA,
  CUSTOMER_POOL_INIT_DATA,
  CUSTOMER_POOL_INPUT_BOX,
  CUSTOMER_POOL_PAGINATION_INFO,
  CUSTOMER_POOL_PAGINATION_INFO_HAVE,
  CUSTOMER_POOL_PARAM_CAHNGES_INQUIRE,
  CUSTOMER_POOL_RESET_PAGE,
  CUSTOMER_POOL_RESET_REQUEST_PARAM
} from "./type";
import axios from "../../axios/axios";
import ipAddress from "../../axios/ipAddress";


const cust_pool = {
  state: () => ({
    search:'',
    degreeStart: '',
    degreeEnd: '',
    grade:'',
    subbranch:'',
    degree:'',
    current: 1,
    size: 12,
    custPools: [],
    total:0,
    sorts:[
      {
        sortColumn:'id',
        sortType:'DESC',
      }
    ]
  }),

  namespaced: true,

  mutations: {
     [CUSTOMER_POOL_INIT_DATA]:(state,payload)=>{
       state.total = payload.total
       state.custPools = [{
         page:1,
         cust_pool:payload.list
       }]
     },
     [CUSTOMER_POOL_PAGINATION_INFO_HAVE]:(state,payload)=>{
       state.current = payload
     },
     [CUSTOMER_POOL_PAGINATION_INFO]:(state,payload)=>{
       state.current = payload.pagination
       state.total = payload.total
       state.custPools = [...state.custPools,
         {page:payload.pagination,cust_pool:payload.list}]
     },
     //输入框内容发生变化
     [CUSTOMER_POOL_INPUT_BOX]:(state,payload)=>{
       const type = payload.type
       const value = payload.value
       switch(type){
         case 0:  //输入框
           state.search = value
           break
         case 1:  //客户等级
           state.grade = value
           break;
         case 2: //分店显示
           state.subbranch = value
           break;
         case 3:  //入池次数
           state.degree = value
           state.degreeStart = payload.start
           state.degreeEnd = payload.end
           break
       }

     },
     //重置页数为1
     [CUSTOMER_POOL_RESET_PAGE]:(state)=>{
       state.current = 1
     },
     //重置请求参数
     [CUSTOMER_POOL_RESET_REQUEST_PARAM]:(state)=>{
         state.current = 1
         state.search = ''
         state.degreeStart =''
         state.degreeEnd = ''
         state.grade = ''
         state.subbranch = ''
         state.degree = ''
     },
     //重新请求该页数据，列表数据重置
     [CUSTOMER_POOL_ANEW_REQUSET_DATA]:(state,payload)=>{
       state.total = payload.total
       state.custPools = [{
         page:state.current,
         cust_pool:payload.list
       }]
     }
  },
  actions: {
      //初始化数据
      [CUSTOMER_POOL_INIT_DATA]:({commit,state},isInit) =>{
        const [custPoolSol] = state.custPools.filter(el => el.page == state.current)
        if(!isInit || !custPoolSol){
          axios.post(`${ipAddress.qi}/admin/a1/customer/pagePond`,
            parameter(state),
            true).then(value => {
            const  success = value.success
            if(success){
              const content = value.content
              commit(CUSTOMER_POOL_INIT_DATA,{
                list:content.records,
                total:content.total
              })
            }
          })
        }
      },
      //页数发生改变时
      [CUSTOMER_POOL_PAGINATION_INFO]:({commit,state},pagination) =>{
        const [custPool] = state.custPools.filter(el =>el.page === pagination)
        if(custPool){  //说明该页存在数据
           commit(CUSTOMER_POOL_PAGINATION_INFO_HAVE,pagination)
        }else{
          let params = parameter(state)
          params = {...params,current:pagination}
          axios.post(`${ipAddress.qi}/admin/a1/customer/pagePond`,
            params,
            true).then(value => {
            const  success = value.success
            if(success){
              const content = value.content
              commit(CUSTOMER_POOL_PAGINATION_INFO,{
                list:content.records,
                total:content.total,
                pagination:pagination
              })
            }
          })
        }
      },
      //点击查询操作
      [CUSTOMER_POOL_PARAM_CAHNGES_INQUIRE]:({commit,dispatch})=>{
        commit(CUSTOMER_POOL_RESET_PAGE)  //重置页数
        dispatch(CUSTOMER_POOL_INIT_DATA)  //重新请求数据
      },
      //重置参数，重新请求数据
      [CUSTOMER_POOL_RESET_REQUEST_PARAM]:({commit,dispatch})=>{
        commit(CUSTOMER_POOL_RESET_REQUEST_PARAM)  //重置所有参数
        dispatch(CUSTOMER_POOL_INIT_DATA)   //重置请求数据
      },
      //重新请求该页数据，列表数据重置
      [CUSTOMER_POOL_ANEW_REQUSET_DATA]:({commit,state}) =>{
        axios.post(`${ipAddress.qi}/admin/a1/customer/pagePond`,
          parameter(state),
          true).then(value => {
          const  success = value.success
          if(success){
            const content = value.content
            commit(CUSTOMER_POOL_ANEW_REQUSET_DATA,{
              list:content.records,
              total:content.total
            })
          }
        })
      }
  },
  getters: {
    //根据页数获取列表信息
    getPagCustPool: state => {
      const custPools = state.custPools
      if (custPools && custPools.length > 0) {
        const [custPoolSol] = custPools.filter(el => el.page == state.current)
        if (custPoolSol) {
          return custPoolSol.cust_pool
        } else {
          return []
        }
      }
    },
    //获取所有的参数信息
    getAllPools:state =>{
      return state
    }
  }
}

//获取请求参数
function parameter(state){
  let condition = {}
  if(state.search){
    condition = {...condition,key:state.search}
  }
  if(state.grade){
     condition={...condition,source:state.grade}
  }
  if(state.subbranch){
    condition={...condition,departmentCode:state.subbranch}
  }
  if(state.degreeStart || state.degreeEnd){
    condition={...condition,timeStart:state.degreeStart,
    timeEnd:state.degreeEnd}
  }
  let params = {
    condition: condition,
    current: state.current,
    size: state.size,
    sorts: state.sorts,
  }
  return params
}


export default cust_pool



// WEBPACK FOOTER //
// ./src/vuex/custPool/index.js